


import {Component, Vue, Watch} from "vue-property-decorator";
import PagedTableView from "@/components/PagedTableView/index.vue";
import api from '@/api'
import {OrganizationUnitDto, SplitBillDetailDto, SplitBillDto} from "@/api/appService";
import BillDetail from "@/views/pays/splitOrder/billDetail.vue";
import BillDetailHeader from "@/views/pays/components/BillDetailHeader.vue";

@Component({
  name: 'BillDetails',
  components: {BillDetailHeader, BillDetail, PagedTableView}
})
export default class BillDetails extends Vue {

  billId: number = 0;

  tableItems: any[] = []

  partialAreas: OrganizationUnitDto[] = []
  stores: OrganizationUnitDto[] = []
  splitBill: SplitBillDto = {};
  currentViewDetail:SplitBillDetailDto = {};
  showDetail = false;
  finishingId = 0;

  queryForm: any = {
    billDate: '',
    organizationUnitId: undefined,
    billId: undefined

  }

  created() {
    this.initialize()
  }

  initialize(){
    if (this.$route.params.billId) {
      this.billId = parseInt(this.$route.params.billId as string, 10);
      this.queryForm.billId = this.billId
      this.fetchBillDetail()
    } else {
      this.billId = 0
      this.queryForm.billId = 0
      this.fetchStores()
    }
  }

  @Watch('$route')
  onRouteChange(){
    console.log('route changed.')
    this.initialize()
  }

  get hiddenQueryForm() {
    return this.billId > 0;
  }

  get currentOu(): OrganizationUnitDto {
    return this.$store.getters['user/ou'] as OrganizationUnitDto;
  }

  get pageHeaderTitle(): string {
    return `账单明细 - ${this.splitBill.billDate} - ${this.splitBill.store?.displayName}`
  }

  fetchBillDetail() {
    api.splitBill.getSplitBill({id: this.billId}).then(dto => {
      this.splitBill = dto;
    })
  }


  fetchData(params: any) {
    return api.splitBill.getAllBillDetails(params)
  }

  fetchStores() {
    api.organizationUnit.getStoresBySession().then(orgs => {
      this.stores = orgs;
    })
  }

  formatAmount(row: any, column: any, cellValue: number) {
    return `￥${(cellValue / 100.0).toFixed(2)}`
  }

  formatPercent(row:any,column:any,cellValue:number){
    return `${cellValue.toFixed(2)}`
  }

  handleViewDetail(row:SplitBillDetailDto){
    this.currentViewDetail = row;
    this.showDetail = true;
  }

  handleFinishSplit(row: SplitBillDetailDto) {
    this.$confirm(
      '剩余冻结金额将解冻给门店（出资方），该笔分账将标记为完成。确认完结分账？',
      '完结分账',
      { type: 'warning' }
    ).then(() => {
      this.finishingId = row.id!;
      api.splitBill.finishSplitBillDetail({ body: { id: row.id } })
        .then(() => {
          this.$message.success('完结分账成功');
          (this.$refs.pagedTableView as any).refreshData();
        })
        .finally(() => {
          this.finishingId = 0;
        });
    });
  }

  downloadBill(){
    window.open(`${process.env.VUE_APP_BASE_API}/api/services/app/SplitBill/DownloadBill?billId=${this.billId}`,'_blank')
  }

}

